<template>
    <div>
      <!-- 地址管理弹框 -->
      <a-modal
       v-model="isModalVisible"
        title="地址管理"
        width="600px"
      >
        <a-form-model ref="addressForm" :model="currentAddress" :rules="rules" layout="horizontal">
          <a-row :gutter="16">
            <!-- 收货人 -->
            <a-col :span="24">
              <a-form-model-item label="收货人" prop="recipientName" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
                <a-input v-model="currentAddress.recipientName" placeholder="请输入收货人" />
              </a-form-model-item>
            </a-col>
  
            <!-- 电话 -->
            <a-col :span="24">
              <a-form-model-item label="电话" prop="contactPhone" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
                <a-input v-model="currentAddress.contactPhone" placeholder="请输入电话" />
              </a-form-model-item>
            </a-col>
  
            <!-- 所在省市区 -->
            <!-- <a-col :span="24">
              <a-form-model-item label="所在省市区" prop="region" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
                <a-cascader
                      v-model="currentAddress.region"
                      :options="regionOptions"
                      :fieldNames="{ label: 'areaName', value: 'areaName', children: 'children' }"
                      placeholder="请选择所在省市区"
                      allowClear
                  />
              </a-form-model-item>
            </a-col> -->
  
            <!-- 详细地址 -->
            <a-col :span="24">
              <a-form-model-item label="详细地址" prop="detailedAddress" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
                <a-textarea v-model="currentAddress.detailedAddress" placeholder="请输入详细地址" />
              </a-form-model-item>
            </a-col>
  
            <!-- 默认地址 -->
            <!-- <a-col :span="24">
              <a-form-model-item>
                <a-checkbox style="margin-left: 20px;" v-model="currentAddress.isDefault">设为默认地址</a-checkbox>
              </a-form-model-item>
            </a-col> -->
          </a-row>
        </a-form-model>
        <template slot="footer">
          <a-button key="submit" type="primary" :loading="loading" @click="handleOk">
            提交
          </a-button>
          <a-button key="back" @click="handleCancel">
            取消
          </a-button>
        </template>
      </a-modal>
    </div>
  </template>
  
  <script>
  import { addAddressList, editAddressList } from '@/api/material.js'
  import { loadAreaTreeCasData } from '@/services/baseCodeSource';

  export default {
    data() {
      return {
        isModalVisible: false,
        currentAddress: {
        id: null,
        recipientName: '',
        contactPhone: '',
        region: [],
        detailedAddress: '',
        isDefault: false,
      },
        // 省市区数据
        regionOptions: [],
        loading: false,
        // 表单校验规则
        rules: {
          recipientName: [{ required: true, message: '请输入收货人', trigger: 'blur' }],
          contactPhone: [
            { required: true, message: '请输入电话', trigger: 'blur' },
            { pattern: /^[1][3-9][0-9]{9}$/, message: '请输入有效的手机号码', trigger: 'blur' },
          ],
          region: [{ required: true, message: '请选择所在省市区', trigger: 'change' }],
          detailedAddress: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
        },
      };
    },
    mounted() {
      this.getArea()
      console.log('@@editData', this.editData)
    },
    methods: {
      // 显示添加地址的对话框
      showAddModal(address) {
        this.resetForm();
        this.isModalVisible = true;
        this.currentAddress = {
          ...address,
          ...{
            region: address.region.split(','),
            isDefault: address.isDefault === 1 ?  true : false
          }
        }
        console.log("🚀 ~ showAddModal ~ this.currentAddress:", this.currentAddress)
      },
      // 重置表单
      resetForm() {
        if (this.$refs.addressForm) {
          this.$refs.addressForm.resetFields();
        }
        this.currentAddress = {
          id: null,
          recipientName: '',
          contactPhone: '',
          region: [],
          detailedAddress: '',
          isDefault: false,
        };
      },
      // 获取地区表
      async getArea() {
      this.regionOptions = await loadAreaTreeCasData();
    },
      // 表单确认提交
      handleOk() {
        this.$refs.addressForm.validate(async (valid) => {
          console.log("🚀 ~ this.$refs.addressForm.validate ~ valid:", valid)
          if (valid) {
           console.log("🚀 ~ handleOk ~ valid:", valid)
           const params = {
            ...this.currentAddress,
            ...{
              isDefault: this.currentAddress.isDefault ? 1 : 0, // 1 默认地址
              region: this.currentAddress.region.join(',')
            }
           }
           let res
           if (params.id) {
             res = await editAddressList(params)
           } else {
             res = await addAddressList(params)
           }
           
           console.log("🚀 ~ handleOk ~ res:", res)
           if (res.code === 1) {
            this.isModalVisible = false
            this.$message.success('保存成功')
            this.$emit('updateList')
           } else {
            this.$message.error('保存失败')
           }
           
           
          } else {
            console.error('表单验证失败');
          }
        });
      },
      handleCancel() {
        this.isModalVisible = false;
      },
    },
  };
  </script>
  
  <style scoped>
  /* 控制表单的最大宽度 */
  .address-form {
    max-width: 600px;
  }
  </style>
  